import cx from 'classnames';

import {CTACard} from '#component/partial';
import {ctaActionPlan, ctaLifestyleSummary} from '#constant/tallyExplorer';
import {sprinkles} from '#style/sprinkles';

import {TallyExplorerCTACardProps} from './TallyExplorerCTACard.types';

export const TallyExplorerCTACard: React.FC<TallyExplorerCTACardProps> = ({
  className,
  variant,
  href,
  onClick,
}) => {
  let ctaCardCopyProps: {title: string; content: string} | null = null;

  if (variant === 'lifestylesummary') {
    ctaCardCopyProps = ctaLifestyleSummary;
  } else if (variant === 'actionplan') {
    ctaCardCopyProps = ctaActionPlan;
  }

  if (!ctaCardCopyProps) {
    return null;
  }

  return (
    <CTACard
      className={cx(sprinkles({pX: [32, 40, 64], pY: [24, 32, 40]}), className)}
      fullWidth={true}
      href={href}
      onClick={onClick}
      {...ctaCardCopyProps}
    />
  );
};
